import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationImageSignResponse } from './types';

type SignOrganizationImageParams = {
  fileName: string;
  fileType: string;
};

export async function signOrganizationImage(
  organizationId: string,
  { fileName, fileType }: SignOrganizationImageParams
) {
  const url = `/web/studio/organizations/${organizationId}/image/sign`;

  /* eslint-disable camelcase */
  const body = {
    file_name: fileName,
    file_type: fileType,
  };
  /* eslint-enable camelcase */

  const response = await api.executePostRequest<ObjectResponse<OrganizationImageSignResponse>>(url, body);

  return response.data;
}
